import React, { useState, useEffect, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import LayoutHOC from "../LayoutHOC";
import useClickOutside from "../../hooks/Screen/useClickOutside";
import CustomerListTable from "../customer/CustomerListTable";
import QuickFilter from "../GlobalFeature/Table/HeadTop/QuickFilter";
// import AddUserModal from './AddUserModal';
import HeaderDashboard from "../HeaderDashboard";
import PermissionHeader from "./PermissionHeader";
import { useFetchUserDataTableDataQuery } from "../../utils/customer/customerTaskTable";
import useRequireAuth from "../../utils/useRequireAuth";
import SideBar from "../Dashboard/SideBar";
import AddPermission from "./AddPermission";
import { useFetchPermissionTableDataQuery } from "../../utils/users/permissions";
import PermissionTable from "./PermissionTable";
import GroupsTable from "../Groups/GroupsTable";
import PermissionLevel from "./PermissionLevel";
import { Dialog, Tooltip } from "@mui/material";
import { ReactComponent as CloseModalImg } from "../../assets/images/closeModalImg.svg";
import { ReactComponent as PencilIcon } from "../../assets/images/pencilIcon.svg";
import OwnerDropDown from "../GlobalFeature/Fields/OwnerDropDown";
import { ALL_USER, EDIT_USER_LIST_BASED_ON_ID, GET_GROUP_DATA } from "../../utils/constants";
import { useDispatch, useSelector } from "react-redux";
import { useLazyFetchPersonInTableQuery } from "../../utils/customer/customerTable";
import { getCommonDataBasedOnId } from "../store/customer/CustomerSocialAddUpdateFunction";
import FirstMessage from "../GlobalFeature/MessageAlert/FirstMessage";
import { orgGroupAddUpdateMember, useOrgGroupAddUpdateMemberMutation } from "../../utils/users/Organizations";
import { pushAlert } from "../../utils/alertSlice";
import Loader from "../UniversalComponents/Loader";
import { hideLoader, showLoader } from "../../utils/loaderSlice";
import ManagePermissionSideBar from "../Dashboard/ManagePermissionSideBar";

const ManagePermission = () => {
  const hashValue = window.location.hash;
  const [activeTab, setActiveTab] = useState("");
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [openPermission, setOpenPermission] = useState(false);
  const [checkUser, setCheckUser] = useState(false);
  const [email, setEmail] = useState("");
  const [grantPrmission, setGrantPrmission] = useState(false);
  const user = useSelector((state) => state.user);
  const [userData, setUserData] = useState(null);
  const [activePerson, setActivePerson] = useState({});
  const [emailCheckData, setEmailCheckData] = useState({});
  const [groupData, setGroupData] = useState({});
  const [quiFilter, setQuiFilter] = useState({ external: 0, status: 1 });
  const { token } = useRequireAuth();
  const companyId = JSON.parse(localStorage.getItem("company_data"))?.company_id;
  const userdata = useRequireAuth();
  const [alert, setAlert] = useState({ visible: false, message: "", type: "" });

  const [fetchPersonInTable, { data: personTableData }] = useLazyFetchPersonInTableQuery();

  const {
    data: customerTableALL,
    refetch: refetchCustomerData,
    isFetching,
  } = useFetchUserDataTableDataQuery({
    pagination: `?company_id=5&per_page=20&page=1&search=&sort_direction=initial&sort_by=null`,
    quiFilter: quiFilter,
    token: token,
  });

  const dispatch = useDispatch();

  useEffect(() => {
    refetchCustomerData();
  }, []);

  const handleCreateGroupClick = () => {
    setOpenPermission(false);
    setGroup(null);
    setPermission(null);
    setIsPopupOpen(true);
  };

  const navigate = useNavigate();
  const [group, setGroup] = useState(null);
  const [permission, setPermission] = useState(null);

  useEffect(() => {
    window.history.replaceState(null, "", window.location.pathname);
    return () => {};
  }, []);

  const handleNavigate = (data, items, header, taskid) => {
    if (items[header?.key]?.field_name === "group_name") {
      setGroup(items);
      setPermission(null);
    } else if (items[header?.key]?.field_name === "permission") {
      setPermission(items);
      setGroup(null);
    }
  };

  const handleCreatePermissionClick = () => {
    setOpenPermission(true);
    setGroup(null);
  };

  const handleGrantPermissionClick = () => {
    setGrantPrmission(true);
  };

  const managePermissionNav = [
    { href: "#CreatePermission", label: "Create Permission", onClick: handleCreatePermissionClick },
    { href: "#CreateGroup", label: "Create Group", onClick: handleCreateGroupClick },
    { href: "#GrantPermission", label: "Grant Permission", onClick: handleGrantPermissionClick },
    { href: "#Check User", label: "Check User", onClick: () => setCheckUser(true) },
  ];

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    window.location.hash = tabId;
  };

  const handleCheckUserClose = () => {
    setCheckUser(false);
  };

  const closeCheckUserOutside = useClickOutside(() => {
    setCheckUser(false);
  });

  const handleEditCheckUser = () => {};

  const tableDetail = {
    tableidclass: "usermodelmember",
  };

  const fetchPersonData = (data) => {
    fetchPersonInTable({ token: userdata?.token, data: data, companyId: companyId });
  };

  const [formData, setFormData] = useState({
    owner: 0,
    email: "",
    // group_id: groupid?.group_name?.id,
  });

  const handleInsert = (item) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      email: item,
    }));
  };

  const TableNav = () => {
    return (
      <div className="flex items-center border bg-white p-2 ps-4 ">
        <ul className="hidden md:flex space-x-6  text-848687 text-16 font-400">
          {managePermissionNav.map((item, index) => (
            <li key={index}>
              <a
                href={item.href}
                onClick={() => {
                  handleTabClick(item.href);
                  if (item.onClick) {
                    item.onClick();
                  }
                }}
                className={`focus:outline-none  ${
                  activeTab === item.href
                    ? "text-[#203C50] font-semibold border-b-2 border-[#203C50]"
                    : "text-2C495D font-normal "
                }`}
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  const [role, setRole] = useState("");
  const [selectedGroupName, setSelectedGroupName] = useState("");
  const [loading, setLoading] = useState(true);
  const [selectedGroup, setSelectedGroup] = useState("");
  const [permissionSideBarActiveItem, setPermissionSideBarActiveItem] = useState("Group");
  const handleSaveData = (person) => {
    setActivePerson(person);
  };
  const getUserInfo = async (event) => {
    event?.preventDefault();
    const url = `${EDIT_USER_LIST_BASED_ON_ID}${activePerson?.id}`;

    try {
      // throw new Error("Error fetching data: ");
      const [userResponse, groupResponse] = await Promise.all([
        getCommonDataBasedOnId(url, token),
        getCommonDataBasedOnId(GET_GROUP_DATA, token),
      ]);

      const userData = userResponse[0];
      setGroupData(groupResponse);

      const matchingGroup = groupResponse?.find((group) => group?.id === userData?.assign_to);
      setSelectedGroupName(matchingGroup?.group_name || "No Group Assigned");

      const role = userData?.permission_level === 1 ? "Contributor" : "Owner";
      setRole(role);

      setLoading(false);
    } catch (error) {
      // console.error("Caught error:", (error) )
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    getUserInfo();
  }, []);

  const hideAlert = () => {
    setAlert((prevState) => ({ ...prevState, visible: false }));
  };

  const initialFormData = {
    owner: "",
    email: "",
  };

  const handleGroupChange = (e) => {
    setSelectedGroup(e.target.value);
  };

  const handleFieldChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };
  const [orgGroupAddUpdateMember, { orgGroupMemberDropLoad, orgGroupMemberDroperror }] =
    useOrgGroupAddUpdateMemberMutation();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const groupData = {
        ...formData,
        // id: editId,
        group: selectedGroup,
      };

      const response = await orgGroupAddUpdateMember({
        token: userdata?.token,
        data: groupData,
      });

      if (response?.success && response?.data?.success) {
        dispatch(
          setAlert({ visible: true, message: response?.data?.message || "Successfully Record Insert", type: "success" })
        );
        // refetchData();
        setFormData(initialFormData);
        // closePopup();
      } else {
        dispatch(setAlert({ visible: true, message: response?.error?.data?.error, type: "danger" }));
        // refetchData();
        // closePopup();
      }
    } catch (err) {
      dispatch(setAlert({ visible: true, message: "Something went wrong", type: "danger" }));
      console.error("Error while adding/updating:", err);
    }
  };

  const handleCancel = () => {
    setCheckUser(false);
  };

  const handleEditClick = () => {
    setCheckUser(false);
    handleGrantPermissionClick();
    const href = "#GrantPermission";
    setActiveTab(href);
    window.history.pushState(null, "", href);
  };

  useEffect(() => {
    if (isFetching) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [isFetching]);

  return (
    <div className="flex flex-col gap-2 justify-around h-screen">
      <HeaderDashboard />
      <div class="flex gap-5 px-4 h-full">
        <div className="w-1/5 ">
          <SideBar />
        </div>
        <div className="w-[15%]  ">
          <ManagePermissionSideBar
            permissionSideBarActiveItem={permissionSideBarActiveItem}
            setPermissionSideBarActiveItem={setPermissionSideBarActiveItem}
          />
        </div>
        {/* below is table which is going to be render based on the state, which one of the item is active in managepermissionsidebar */}

        <div className="">{permissionSideBarActiveItem === "Group" ? <></> : <></>}</div>
        {/* <div className="w-full mt-2">
          {group?.group_name && !openPermission ? (
            <Fragment>
              <GroupsTable handleNavigates={handleNavigate} TableNav={TableNav} groupid={group} setGroup={setGroup} />
            </Fragment>
          ) : permission?.permission || openPermission ? (
            <Fragment>
              <PermissionLevel
                handleNavigate={handleNavigate}
                TableNav={TableNav}
                ButtonEvent={() => {
                  setPermission(null);
                  setOpenPermission(false);
                }}
                PermissionLevelId={permission}
              />
            </Fragment>
          ) : (
            <PermissionTable
              handleNavigate={handleNavigate}
              TableNav={TableNav}
              isPopupOpen={isPopupOpen}
              setIsPopupOpen={setIsPopupOpen}
            />
          )}
        </div> */}
      </div>
      {checkUser && (
        <Dialog
          open={checkUser}
          // onClose={() => setCheckUser(false)}
          // ref={closeCheckUserOutside}
        >
          <form
          // onSubmit={getUserInfo}
          >
            <div className="p-2 px-4 w-[510px] pb-4">
              <div className="flex justify-between items-center border-b border-BECBD3">
                <h5 className="text-16 text-434852 font-500">Check User</h5>
                <button
                  type="button"
                  className="text-454545 hover:bg-F1F5F8 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
                  data-modal-hide="assets-modal"
                  onClick={handleCheckUserClose}
                >
                  <CloseModalImg className="w-3 h-3" />
                </button>
              </div>
              <div className="mt-2">
                <div>
                  <label htmlFor="email" className="block text-sm pb-1">
                    <span className=" text-434852 ">Name</span>
                    <span className=" text-red-500"> *</span>
                  </label>
                  <OwnerDropDown
                    tableidclass={tableDetail.tableidclass}
                    fetchPersonInTable={fetchPersonData}
                    DropData={personTableData}
                    handleInsert={handleInsert}
                    owner={formData?.id}
                    fieldname={"email"}
                    handleSaveData={handleSaveData}
                  />
                </div>
              </div>
              <div className="mt-2 flex justify-end gap-3">
                <button
                  className="bg-F4F4F4 text-535252 text-14 font-500 px-4 py-2 rounded"
                  type="button"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
                <button
                  className="bg-1D4469 text-white text-14 font-500 px-4 py-2 rounded"
                  type="submit"
                  onClick={getUserInfo}
                >
                  Check Now
                </button>
              </div>
              <div className="w-full mt-4">
                <label className="w-full flex text-16 text-434852 font-600 py-2">Group Name</label>
                <div className="flex justify-between">
                  <button className="bg-EBEBEB p-2 px-5  rounded">
                    {selectedGroupName ? selectedGroupName : "N/A"}
                  </button>
                  <Tooltip
                    placement="top"
                    title="Edit"
                    PopperProps={{
                      modifiers: [
                        {
                          name: "offset",
                          options: {
                            offset: [0, -5],
                          },
                        },
                      ],
                    }}
                    componentsProps={{
                      tooltip: {
                        sx: {
                          backgroundColor: "black",
                          color: "white",
                          boxShadow: "none",
                          height: "23px",
                          display: "flex",
                          alignItems: "center",
                        },
                      },
                    }}
                  >
                    <button
                      className="bg-[#E9EFF5] flex items-center justify-center rounded-full p-2 w-8 h-8"
                      onClick={handleEditClick}
                    >
                      <PencilIcon className="w-4 h-4 text-gray-700" />
                    </button>
                  </Tooltip>
                </div>
              </div>
              <div className="w-full mt-4">
                <label className="w-full flex text-16 text-434852 font-600 py-2">Access Type</label>
                <button className="bg-EBEBEB p-2 px-5  rounded">{role ? role : "N/A"}</button>
              </div>
            </div>
          </form>
        </Dialog>
      )}

      {grantPrmission && (
        <Dialog open={grantPrmission} onClose={() => setGrantPrmission(false)}>
          <div className="fixed inset-0 flex items-center justify-center z-[9999] bg-gray-900 bg-opacity-50">
            <div className="relative mt-18 bg-white  font-popns drop-shadow-lg  rounded-md w-[520px] overflow-hidden no-scrollbar">
              <div className="mx-6 flex items-center justify-between py-4 md:py-3  border-b border-BECBD3 rounded-t">
                <h3 className="text-base text-434852 font-500">Grant Permission</h3>
                <button
                  onClick={() => setGrantPrmission(false)}
                  type="button"
                  className="text-454545  hover:bg-F1F5F8 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
                  data-modal-hide="assets-modal"
                >
                  <CloseModalImg className="w-3 h-3" />
                  <span className="sr-only">Close modal</span>
                </button>
              </div>

              <form className={`w-full lg:max-h-[70vh]  pt-2`} onSubmit={handleSubmit}>
                <div className="grid px-6 py-1">
                  <div>
                    <label htmlFor="email" className="block text-sm pb-1">
                      <span className=" text-434852 ">Name</span>
                      <span className=" text-red-500"> *</span>
                    </label>
                    <OwnerDropDown
                      tableidclass={tableDetail.tableidclass}
                      fetchPersonInTable={fetchPersonData}
                      DropData={personTableData}
                      handleInsert={handleInsert}
                      owner={formData?.email}
                      fieldname={"email"}
                    />
                  </div>
                </div>
                <div className="basis-5/5  px-6 pt-2">
                  <label className="text-14 text-434852 font-400">Group</label>
                  <select
                    id={`group`}
                    name="group"
                    onClick={getUserInfo}
                    onChange={handleGroupChange}
                    className={`form-select border border-BFBFBF text-383838 text-sm  focus:ring-blue-500 focus:border-blue-500 block w-full px-2 mb-1 py-1`}
                  >
                    {groupData.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.group_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="basis-5/5 mb-3 px-6 pt-2">
                  <label htmlFor="Designation" className="block pb-1 text-sm text-434852">
                    Access <span className=" text-red-500"> *</span>
                  </label>
                  <select
                    id={`owner`}
                    name="owner"
                    onChange={handleFieldChange}
                    className={`form-select border border-BFBFBF text-383838 text-sm  focus:ring-blue-500 focus:border-blue-500 block w-full px-2 mb-1 py-1`}
                  >
                    <option value="0" selected={formData?.owner === 0}>
                      Contributor
                    </option>
                    <option value="1" selected={formData?.owner === 1}>
                      Owner
                    </option>
                  </select>
                </div>

                <div className="sticky bottom-0 pb-2 pr-4 flex justify-end  text-md w-full rounded-none z-[9998]">
                  <div className="px-2 mr-1">
                    <button
                      onClick={() => setGrantPrmission(false)}
                      type="button"
                      className="w-28 text-535252 bg-F4F4F4 hover:bg-eeeeee cancel-btn focus:ring-4 focus:ring-blue-300 font-normal px-5 py-1 text-center rounded-5px"
                    >
                      CANCEL
                    </button>
                    <button
                      type="submit"
                      className="w-28 text-white bg-1D4469 hover:bg-20486F save-btn font-normal border border-gray-200 py-1 px-5 ms-3 rounded-5px"
                    >
                      SAVE
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Dialog>
      )}
    </div>
  );
};

export default ManagePermission;
